<template>
    <div class="tag-filter">
        <multiselect 
            v-model="value"
            :placeholder="$tc('user.filter.usergroup')"
            label="name" track-by="name"
            :options="options"
            :searchable="false"
            @input="inputHandler"
        >
            <template slot="option" slot-scope="props">
                <div class="option__desc">
                    <span class="option__title">
                        {{ props.option.name }}
                    </span>
                </div>
            </template>
        </multiselect>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import debounce from 'lodash.debounce'
import {refreshGroups} from '../../store'
export default {
  components: {
    Multiselect
  },
  mounted () {
    if (!this.options) {
      refreshGroups(this.$store)
    }
  },

  data: () => ({
    value: []
  }),
  methods: {
    inputHandler: debounce(function (chosenGroup) {
      this.$emit('groups-selected', chosenGroup)
    }, 1000)
  },
  computed: {
    options () {
      if (this.$store.state.groups) {
        return this.$store.state.groups.map(x => x.groups).flat()
      }
      return []
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
